<template>
  <div class="container">
    <div class="btn-wrapper">
      <el-button class="add-new-btn" @click="handleViewAdd(1)">
        <i class="iconfont iconProperty1tianjia"></i> Add
      </el-button>
    </div>
    <div class="risk-table risklist-table">
      <el-table
        ref="table"
        :data="list"
        :height="tableHeight"
        :indent="0"
        v-loading="loading"
        header-row-class-name="table-header-row"
        border
        row-key="rowId"
      >
        <template slot="empty">
          <Empty />
        </template>
        <el-table-column label="ID" prop="riskLevelId" min-width="96px"></el-table-column>
        <el-table-column label="Name" min-width="118px">
          <template v-slot="{row}">
            <div>
              <span>{{row.riskLevel}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="User Count" prop="userCount" min-width="101px"></el-table-column>
        <el-table-column
          label="Max Stake Factor"
          prop="maxStakeFactor"
          min-width="150px"
          align="center"
        >
          <template slot="header">
            <span>Max Stake Factor</span>
            <el-tooltip
              class="item"
              effect="dark"
              content="The factor of the per bet limit"
              placement="top"
            >
              <i class="el-icon-warning-outline" style="color: red;margin-left: 6px;"></i>
            </el-tooltip>
          </template>
          <template v-slot="{row}">
            <div
              style="text-align: center;"
              v-if="row.maxStakeFactor"
            >{{+(row.maxStakeFactor * 100).toFixed(4)}}%</div>
          </template>
        </el-table-column>
        <el-table-column label="Self-Risk" prop="userCount" min-width="101px">
          <template v-slot="{row}">
            <span>{{row.selfRisk == 1 ? 'ON' : 'OFF'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="Operation" min-width="155px">
          <template v-slot="{row}">
            <div v-if="row.riskLevelId != 0">
              <el-button class="table-inner-btn" @click="handleViewAdd(2,row)">Modify</el-button>
              <!-- <el-button class="table-inner-btn" @click="handleViewDetail(row)">Details</el-button> -->
              <el-button class="table-inner-btn" @click="handleViewAdd(4,row)">History</el-button>
              <el-button
                class="table-inner-btn"
                v-if="row.userCount == 0"
                @click="handleViewAdd(3,row)"
              >Delete</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-wrapper inline-wrapper">
      <el-pagination
        class="inline-right"
        :total="total"
        :current-page="queryData.current"
        :page-size="queryData.size"
        :page-sizes="[50, 100, 200]"
        @current-change="changePage"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>

    <dia ref="dialogDom" class="label-dialog">
      <!-- 添加1修改2 -->
      <div v-if="num == 2 || num == 1">
        <el-form :model="queryForm" label-width="160px">
          <el-form-item label="User Limit Name">
            <el-input v-model="queryForm.riskLevel"></el-input>
          </el-form-item>
          <el-form-item label="Max Stake Factor">
            <el-input
              v-model="queryForm.maxStakeFactor"
              placeholder="100"
              @blur="inputMaxStake()"
              onkeyup="this.value=this.value.match(/\d+\.?\d{0,4}/);this.dispatchEvent(new Event('input'))"
            >
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="Self-Risk">
            <el-select v-model="queryForm.selfRisk" filterable clearable placeholder="Self-Risk">
              <el-option
                v-for="item in selfRiskList"
                :key="item.id"
                :label="item.label"
                :value="Number(item.id)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Remark">
            <el-input v-model="queryForm.remark"></el-input>
          </el-form-item>
        </el-form>
        <div class="dialog-footer table-search-part">
          <el-button class="search-btn" v-if="num == 1" @click="handleListAdd()">Confirm</el-button>
          <el-button class="search-btn" v-if="num == 2" @click="handleListModify()">Confirm</el-button>
          <el-button class="clear-btn" @click="listClose()">Cancel</el-button>
        </div>
      </div>
      <!-- history4 -->
      <div v-if="num == 4">
        <el-table
          ref="table"
          :data="historyList"
          height="500"
          v-loading="loadingItem"
          header-row-class-name="table-header-row"
          border
        >
          <template slot="empty">
            <Empty />
          </template>
          <el-table-column label="Modify Time" align="left">
            <template v-slot="{row}">
              <div class="level-box">
                <span>{{formatUtc(row.updateTime || row.createTime)}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="User Limit Name" align="left">
            <template v-slot="{row}">
              <div class="level-box">
                <span>{{row.riskLevel}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Max Stake Factor" prop="warning" align="left">
            <template v-slot="{row}">
              <div
                style="text-align: left;"
                v-if="row.maxStakeFactor"
              >{{+(row.maxStakeFactor * 100).toFixed(4)}}%</div>
            </template>
          </el-table-column>
          <el-table-column label="Self-Risk" prop="levelId" align="left">
            <template v-slot="{row}">
              <span>{{row.selfRisk == 1 ? 'ON' : 'OFF'}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Remark" prop="remark" align="left"></el-table-column>
          <el-table-column label="Modifier" prop="updateUser" align="left"></el-table-column>
        </el-table>
        <div class="pagination-wrapper inline-wrapper">
          <el-pagination
            class="inline-right"
            :total="totalAert"
            :current-page="queryHistoryData.current"
            :page-size="queryHistoryData.size"
            :page-sizes="[50, 100, 200]"
            @current-change="changeAlertPage"
            @size-change="handleSizeAlertChange"
            layout="total, sizes, prev, pager, next, jumper"
          ></el-pagination>
        </div>
        <div class="dialog-footer table-search-part" style="padding-top: 20px;">
          <el-button class="clear-btn" @click="CloseHistory()">Cancel</el-button>
        </div>
      </div>
      <!-- 删除3 -->
      <div v-if="num == 3" class="dialog-footer table-search-part">
        <el-button class="search-btn" @click="Delete()">Confirm</el-button>
        <el-button class="clear-btn" @click="Close()">Cancel</el-button>
      </div>
    </dia>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import dia from "@/components/dialog/index";
import Empty from "@/components/empty/index";
import {
  getRiskList,
  getRiskDelete,
  getRiskUpdate,
  getRiskAdd
} from "@/api/risk";
import { getTcsSportList } from "@/api/memberDetail";
import { getHistoryList } from "@/api/member";

export default {
  name: "RiskList",
  data() {
    return {
      list: [],
      sportList: [],
      loadingItem: false,
      historyList: [],
      totalAert: 0,
      total: 0,
      loading: false,
      queryData: {
        current: 1,
        size: 50
      },
      queryHistoryData: {
        riskLevelId: "",
        current: 1,
        size: 50
      },
      queryForm: {
        riskLevel: "",
        maxStakeFactor: "",
        selfRisk: 0,
        remark: ""
      },
      selfRiskList: [
        {
          id: 1,
          label: "ON"
        },
        {
          id: 0,
          label: "OFF"
        }
      ],
      pendingList: [
        {
          id: "5",
          label: "5s"
        },
        {
          id: "10",
          label: "10s"
        },
        {
          id: "15",
          label: "15s"
        },
        {
          id: "30",
          label: "30s"
        },
        {
          id: "60",
          label: "60s"
        },
        {
          id: "-1",
          label: "Manual"
        }
      ],
      tableHeight: window.innerHeight,
      title: "",
      num: ""
    };
  },
  methods: {
    async getList() {
      this.loading = true;
      try {
        const res = await getRiskList(this.queryData);
        const data = res.data || {};
        this.list = data.records || [];
        this.total = data.total;
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.loading = false;
      }
    },
    // 分页
    changePage(e) {
      this.queryData.current = e;
      this.getList();
    },
    // 列表显示条目
    handleSizeChange(e) {
      this.queryData.size = e;
      this.queryData.current = 1;
      this.getList();
    },
    // 查看详情
    // handleViewDetail(data) {
    //   this.$router.push({
    //     path: "/risk/detail",
    //     query: { riskLevelId: data.riskLevelId }
    //   });
    // },
    // 修改或者添加
    // handleViewModify(data) {
    //   this.$router.push({
    //     path: "/risk/modify",
    //     query: { riskLevelId: data.riskLevelId }
    //   });
    // },
    // 添加
    // handleViewAdd(data) {
    //   this.$router.push({ path: "/risk/add" });
    // },
    handleViewAdd(num, data) {
      this.num = num;
      if (num == 1) {
        // 添加
        this.title = "Add User Limit";
        this.queryForm.riskLevel = "";
        this.queryForm.maxStakeFactor = "";
        this.queryForm.selfRisk = 0;
        this.queryForm.remark = "";
        this.queryForm.riskLevelId = "";
        this.$refs["dialogDom"].isShowDia(this.title, true, "600px");
      } else if (num == 2) {
        // 修改
        this.title = "Modify User Limit";
        this.queryForm.riskLevel = data.riskLevel;
        this.queryForm.riskLevelId = data.riskLevelId;
        this.queryForm.maxStakeFactor = +(data.maxStakeFactor * 100).toFixed(4);
        this.queryForm.selfRisk = data.selfRisk;
        this.queryForm.remark = data.remark;
        this.$refs["dialogDom"].isShowDia(this.title, true, "600px");
      } else if (num == 4) {
        this.title = "User Limit History";
        this.queryHistoryData.riskLevelId = data.riskLevelId;
        this.queryHistoryData.current = 1;
        this.queryHistoryData.size = 50;
        this.$refs["dialogDom"].isShowDia(this.title, true, "1100px");
        this.getHistoryList();
      } else if (num == 3) {
        // 删除
        this.title = "Delete The User Limit?";
        this.$refs["dialogDom"].isShowDia(this.title, true, "323px");
        this.queryData.riskLevelId = data.riskLevelId;
      }
    },
    inputMaxStake() {
      this.list.map(item => {
        if (item.maxStakeFactor < 0.0001) {
          item.maxStakeFactor = 0.0001;
        }
      });
    },
    async handleListAdd(data) {
      let maxStakeFactor = "";
      if (this.queryForm.maxStakeFactor) {
        maxStakeFactor = this.queryForm.maxStakeFactor / 100;
      }
      let param = { ...this.queryForm, maxStakeFactor: maxStakeFactor };
      try {
        const res = await getRiskAdd(param);
        if (res.success) {
          this.$message({ message: "update success", type: "success" });
          this.getList();
          this.listClose();
        }
      } catch (error) {
        this.listClose();
      }
    },
    async handleListModify(data) {
      let maxStakeFactor = "";
      if (this.queryForm.maxStakeFactor) {
        maxStakeFactor = this.queryForm.maxStakeFactor / 100;
      }
      let param = { ...this.queryForm, maxStakeFactor: maxStakeFactor };
      try {
        const res = await getRiskUpdate(param);
        if (res.success) {
          this.$message({ message: "update success", type: "success" });
          this.getList();
          this.listClose();
        }
      } catch (error) {
        this.listClose();
      }
    },
    listClose() {
      this.$refs["dialogDom"].isShowDia(this.title, false, "600px");
    },
    async getHistoryList() {
      try {
        this.loadingItem = true;
        const res = await getHistoryList(this.queryHistoryData);
        this.historyList = res.data.records || [];
        this.totalAert = Number(res.data.total);
        this.loadingItem = false;
      } catch (error) {
        this.historyList = [];
        this.loadingItem = false;
      }
    },
    // utc时间
    formatUtc(time) {
      if(!time) return "";
      return this.$moment(+time).format("YYYY-MM-DD HH:mm:ss");
    },
    // 分页
    changeAlertPage(e) {
      this.queryHistoryData.current = e;
      this.getHistoryList();
    },
    // 列表显示条目
    handleSizeAlertChange(e) {
      this.queryHistoryData.size = e;
      this.queryHistoryData.current = 1;
      this.getHistoryList();
    },
    // 查看历史
    // handleViewHistory(data) {
    //   this.$router.push({
    //     path: "/risk/history",
    //     query: { levelId: data.riskLevelId }
    //   });
    // },
    // 删除
    handleDelete(data) {
      this.$refs["dialogDom"].isShowDia(this.title, true, "323px");
      this.queryData.riskLevelId = data.riskLevelId;
    },
    async Delete() {
      const res = await getRiskDelete(this.queryData);
      if (res.code == 0) {
        this.$message({ message: "delete success", type: "success" });
        this.getList();
        this.Close();
      }
    },
    Close() {
      this.$refs["dialogDom"].isShowDia(this.title, false, "323px");
    },
    CloseHistory() {
      this.$refs["dialogDom"].isShowDia(this.title, false, "1100px");
    },
    async getSportList() {
      try {
        const res = await getTcsSportList({ matchType: '' });
        const data = res.data || {};
        this.sportList = data || [];
      } catch (error) {
        this.sportList = [];
      }
    }
  },
  activated() {
    this.getList();
    //this.getSportList();
    this.$nextTick(() => {
      let self = this;
      self.tableHeight =
        window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      };
    });
  },
  components: {
    dia,
    Empty
  }
};
</script>

<style lang="scss" scoped>
.btn-wrapper {
  margin: 20px 0;
}
/deep/.risk-table {
  .el-table th {
    padding: 6px 0;
  }
}
</style>
